const storeName = 'UI';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    SET_WINDOW_SIZE: `${storeName}.SET_WINDOW_SIZE`,
    WINDOW_RESIZE: `${storeName}.WINDOW_RESIZE`,
    SET_MINICART_POPOVER_DATA: `${storeName}.SET_MINICART_POPOVER_DATA`,
    TOOGLE_MINICART_POPOVER_DATA: `${storeName}.TOOGLE_MINICART_POPOVER_DATA`,
    FORCE_CLOSE_MINICART_POPOVER: `${storeName}.FORCE_CLOSE_MINICART_POPOVER`,
    SET_POPOVER_STATUS: `${storeName}.SET_POPOVER_POPOVER`,
    SET_LOGIN_POPOVER_OPENED: `${storeName}.SET_LOGIN_POPOVER_OPENED`,
    OPEN_MODAL: `${storeName}.OPEN_MODAL`,
    OPEN_DIALOG: `${storeName}.OPEN_DIALOG`,
    CLOSE_DIALOG: `${storeName}.CLOSE_DIALOG`,
    CLOSE_DIALOG_BY_NAME: `${storeName}.CLOSE_DIALOG_BY_NAME`,
    CANCEL_MODAL: `${storeName}.CANCEL_MODAL`,
    OK_MODAL: `${storeName}.OK_MODAL`,
    SET_SCROLL_TOP: `${storeName}.SET_SCROLL_TOP`,
    SCROLL_TO_TOP: `${storeName}.SCROLL_TO_TOP`,
    SCROLL_TO_CENTER: `${storeName}.SCROLL_TO_CENTER`,
    SCROLL_INTO_VIEW: `${storeName}.SCROLL_INTO_VIEW`,
    SET_LANG: `${storeName}.SET_LANG`,
    STORE_INFO_STATUS: `${storeName}.STORE_INFO_STATUS`,
    HIDE_FILTERS_MENU: `${storeName}.HIDE_FILTERS_MENU`,
    SHOW_FILTERS_MENU: `${storeName}.SHOW_FILTERS_MENU`,
    SCROLL_TO_APPLIED_FILTER: `${storeName}.SCROLL_TO_APPLIED_FILTER`,
    SET_MINICART_FORCED_MESSAGES: `${storeName}.SET_MINICART_FORCED_MESSAGES`,
    REMOVE_MINICART_FORCED_MESSAGES: `${storeName}.REMOVE_MINICART_FORCED_MESSAGES`,
    OPEN_TAB: `${storeName}.OPEN_TAB`,
    ADD_TAB_LINK: `${storeName}.ADD_TAB_LINK`,
    ADD_ACCOUNT_NAVIGATION: `${storeName}.ADD_ACCOUNT_NAVIGATION`,
    SET_ACCOUNT_NAVIGATION_ACTIVE: `${storeName}.SET_ACCOUNT_NAVIGATION_ACTIVE`,
    SET_NAVIGATION: `${storeName}.SET_NAVIGATION`,
    SET_MY_ACCOUNT_NAVIGATION: `${storeName}.SET_MY_ACCOUNT_NAVIGATION`,
    SET_FLY_DOWN_EFFECT: `${storeName}.SET_FLY_DOWN_EFFECT`,
    RESET_FLY_DOWN_EFFECT: `${storeName}.RESET_FLY_DOWN_EFFECT`,
    ACCORDION_OPEN: `${storeName}.ACCORDION_OPEN`,
    ACCORDION_CLOSE: `${storeName}.ACCORDION_CLOSE`,
    PREVENT_CLICK: `${storeName}.PREVENT_CLICK`,
    VARIANT_SELECT_STATUS: `${storeName}.VARIANT_SELECT_STATUS`,
    ADD_TO_VISIBLE_ELEMENTS: `${storeName}.ADD_TO_VISIBLE_ELEMENTS`,
    REMOVE_FROM_VISIBLE_ELEMENTS: `${storeName}.REMOVE_FROM_VISIBLE_ELEMENTS`,
    NORMALIZE_DATEPICKER: `${storeName}.NORMALIZE_DATEPICKER`,
    SET_HEADER_SCROLLED: `${storeName}.SET_HEADER_SCROLLED`,
    SET_PAGE_SCROLLED_DOWN: `${storeName}.SET_PAGE_SCROLLED_DOWN`,
    SET_HOVERED_MINI_CART_PRODUCT: `${storeName}.SET_HOVERED_MINI_CART_PRODUCT`,
    SET_FACET_SEARCH_VALUE: `${storeName}.SET_FACET_SEARCH_VALUE`,
    OPEN_REVIEWS_WRAPPER: `${storeName}.OPEN_REVIEWS_WRAPPER`,
    CLOSE_REVIEWS_WRAPPER: `${storeName}.CLOSE_REVIEWS_WRAPPER`,
    SET_AUTO_LOGIN_MESSAGE: `${storeName}.SET_AUTO_LOGIN_MESSAGE`,
    SET_PAGE_VIEW_TYPE: `${storeName}.SET_PAGE_VIEW_TYPE`,
    RESET_PAGE_VIEW_TYPE: `${storeName}.RESET_PAGE_VIEW_TYPE`,
    SCROLL_TO_ANCHOR_GROUP: `${storeName}.SCROLL_TO_ANCHOR_GROUP`,
    RESET_SCROLL_ANCHOR_GROUP: `${storeName}.RESET_SCROLL_ANCHOR_GROUP`,
    SET_PLP_VIEW_TYPES: `${storeName}.SET_PLP_VIEW_TYPES`,
    SET_PLP_VIEW_TYPE: `${storeName}.SET_PLP_VIEW_TYPE`,
    SET_CONTENT_ITEMS_AMOUNT: `${storeName}.SET_CONTENT_ITEMS_AMOUNT`,
    STICKY_BAR_TOGGLE: `${storeName}.STICKY_BAR_TOGGLE`,
    SET_CUSTOM_HANDLE_CLOSE: `${storeName}.SET_CUSTOM_HANDLE_CLOSE`,
    TOP_BRANDS_SHOW: `${storeName}.TOP_BRANDS_SHOW`,
    TOP_BRANDS_HIDE: `${storeName}.TOP_BRANDS_HIDE`,
    CLEAR_STATUS_CODE: `${storeName}.CLEAR_STATUS_CODE`,
    NEWSLETTER_DISCLAIMER_SHOW: `${storeName}.NEWSLETTER_DISCLAIMER_SHOW`,
    SET_HOVERED_GWP_PRODUCT: `${storeName}.SET_HOVERED_GWP_PRODUCT`,
    ADD_ELEMENTS_TO_REFRESH: `${storeName}.ADD_ELEMENT_TO_REFRESH`,
    REMOVE_ELEMENT_TO_REFRESH: `${storeName}.REMOVE_ELEMENT_TO_REFRESH`,
    ADD_PRODUCT_REVIEW: `${storeName}.ADD_PRODUCT_REVIEW`,
    BV_INITIALIZE: `${storeName}.BV_INITIALIZE`,
    SHOW_ADD_VOUCHER_FORM: `${storeName}.SHOW_ADD_VOUCHER_FORM`,
    HIDE_ADD_VOUCHER_FORM: `${storeName}.HIDE_ADD_VOUCHER_FORM`,
    SET_ACTIVE_ALPHABET_FILTER: `${storeName}.SET_ACTIVE_ALPHABET_FILTER`,
    CLEAR_ACTIVE_ALPHABET_FILTER: `${storeName}.CLEAR_ACTIVE_ALPHABET_FILTER`,
    SHOW_GREETINGS: `${storeName}.SHOW_GREETINGS`,
    CONTENT_VIEW_CHANGED: `${storeName}.CONTENT_VIEW_CHANGED`,
    EXPAND_ACCORDION: `${storeName}.EXPAND_ACCORDION`,
    COMPARE_EXPANDED_ACCORDIONS_GROUP: `${storeName}.COMPARE_EXPANDED_ACCORDIONS_GROUP`,
    RESET_EXPANDED_ACCORDIONS: `${storeName}.RESET_EXPANDED_ACCORDIONS`,
    SHOW_GWP_ITEMS: `${storeName}.SHOW_GWP_ITEMS`,
    UNLOCK_GWP_FLOW: `${storeName}.UNLOCK_GWP_FLOW`,
    CONNECTED_AND_SHOW: `${storeName}.CONNECTED_AND_SHOW`,
    CONNECTED_AND_SHOW_CONTAINER: `${storeName}.CONNECTED_AND_SHOW_CONTAINER`,
    FORCE_CLICK_AVAILABILITY_IN_BRANCH: `${storeName}.FORCE_CLICK_AVAILABILITY_IN_BRANCH`,
    SET_MIN_ITEMS_TO_SHOW: `${storeName}.SET_MIN_ITEMS_TO_SHOW`,
    REGISTER_IFRAME: `${storeName}.REGISTER_IFRAME`,
    NOTIFY_IFRAME: `${storeName}.NOTIFY_IFRAME`,
    SCROLL_TO_TARGET: `${storeName}.SCROLL_TO_TARGET`,
    CLEAR_PINCODE: `${storeName}.CLEAR_PINCODE`,
    OPEN_LIGHT_POPUP: `${storeName}.OPEN_LIGHT_POPUP`,
    CLOSE_LIGHT_POPUP: `${storeName}.CLOSE_LIGHT_POPUP`,
    CHECK_OPEN_LIGHT_POPUP: `${storeName}.CHECK_OPEN_LIGHT_POPUP`,

};
